import React, { useEffect, useRef } from 'react'
import "./Bubble.css"
import { Divider } from 'antd'
import Ring from './Icon/Ring';
import Flower from './Icon/Flower';
import { randomInt } from './bubble_function';
import BowTie from './Icon/BowTie';
import Heart from './Icon/Heart';
import { correct_media } from 'general_function';

const BUBBLE_THEMES = [
    {
        "--bubble-bg-start": "#fff8f3",
        "--bubble-bg-end": "#ffe9ef",
        "--bubble-border": "#efc7d2",
        "--bubble-text": "#5d2a3c",
        "--bubble-author": "#8f5f70",
        "--bubble-shadow": "rgba(110, 49, 72, 0.16)",
    },
    {
        "--bubble-bg-start": "#fff6fa",
        "--bubble-bg-end": "#ffdfe9",
        "--bubble-border": "#efbfd0",
        "--bubble-text": "#61263d",
        "--bubble-author": "#9a6078",
        "--bubble-shadow": "rgba(120, 50, 82, 0.16)",
    },
    {
        "--bubble-bg-start": "#fff7fd",
        "--bubble-bg-end": "#ffe8f8",
        "--bubble-border": "#ebc5df",
        "--bubble-text": "#5c2f53",
        "--bubble-author": "#8d6285",
        "--bubble-shadow": "rgba(107, 62, 97, 0.15)",
    },
    {
        "--bubble-bg-start": "#fff4f8",
        "--bubble-bg-end": "#ffd9e6",
        "--bubble-border": "#eeb5c8",
        "--bubble-text": "#6a2a46",
        "--bubble-author": "#9f5f7e",
        "--bubble-shadow": "rgba(126, 55, 88, 0.16)",
    },
]

export default function Bubble({ wish, position, animation = false, doneQueue, onDoneAnimation, fontSize = 16 }) {
    const bubbleRef = useRef();
    const randomIcon = useRef(null);
    const randomTheme = useRef(null);
    const framePaddingY = Math.round(fontSize * 4.5);
    const framePaddingX = Math.round(fontSize * 3);
    const messagePadding = Math.round(Math.max(fontSize * 0.7, 8));
    const authorPadding = Math.round(Math.max(fontSize * 0.4, 5));

    if (randomIcon.current === null && animation) {
        randomIcon.current = randomInt(1, 4);
    }
    if (randomTheme.current === null) {
        randomTheme.current = BUBBLE_THEMES[randomInt(0, BUBBLE_THEMES.length - 1)];
    }
    useEffect(() => {
        if (bubbleRef.current) {
            doneQueue && doneQueue([bubbleRef.current.offsetWidth, bubbleRef.current.offsetHeight])
        }
        // eslint-disable-next-line
    }, []);

    return <div ref={bubbleRef} className='animation-float-up' style={{
        padding: `${framePaddingY}px ${framePaddingX}px`,
        position: "absolute",
        left: position[0],
        top: "100vh",
    }} onAnimationEnd={() => onDoneAnimation && onDoneAnimation(wish.id)}>
        <div className={`message-bubble${animation ? " animation" : ""}`} style={{
            ...randomTheme.current,
        }}>
            <div className='bubble-icon'>
                {
                    randomIcon.current === 1 ? <Ring /> :
                    randomIcon.current === 2 ? <Flower /> : 
                    randomIcon.current === 3 ? <BowTie /> : 
                    randomIcon.current === 4 ? <Heart /> : 
                    <></>
                }
            </div>
            <div className='message-bubble-message' style={{ fontSize, padding: messagePadding }}>
                {wish.message}
            </div>
            <Divider />
            <div className='message-bubble-author' style={{ fontSize: Math.max(fontSize - 2, 12), padding: authorPadding }}>
                {wish.name}
            </div>
            {animation && wish.image && <div className='bubble-image'>
                <img alt='ảnh' src={correct_media(wish.image)}/>
            </div>}
        </div>
    </div>
}
